import { IPriceMandantSettings, IPriceMandantSettingsV2 } from "./article-price";
import { SearchboxViewType } from "./searchbox";
import {
    IArticleSuggestion,
    IContentSuggestion,
    IFlexibleSetSuggestion
} from "./suggestion-response";
import {
    IMappedArticle,
    IMappedContent,
    IMappedTopSearchQuery,
    IPromotion
} from "./suggestion-items";
import { CustomerEnum, DeviceEnum } from "./context-detection";
import { IHandleKeyboardNavigation } from "./keyboard-navigation";
import { StoredSearchQuery } from "./stored-search-queries";

export interface ISuggestionListProps {
    navigationRef: React.Ref<IHandleKeyboardNavigation>;
    trackingEndpoint: string;
    portal: string;
    culture: string;
    articles: IArticleSuggestion[];
    flexibleSets: IFlexibleSetSuggestion[];
    contents: IContentSuggestion[];
    topSearchQueries: string[];
    featurePromotion?: string;
    customerType: CustomerEnum;
    searchTerm: string;
    isMobileShop: boolean;
    view: SearchboxViewType;
    searchTarget: string;
    priceMandantSettings: IPriceMandantSettings;
    priceMandantSettingsV2: IPriceMandantSettingsV2;
    pageViewLogDataId: string;
    deviceType: DeviceEnum;
}

export interface ISuggestionColumnsProps {
    navigationRef: React.Ref<IHandleKeyboardNavigation>;
    trackingEndpoint: string;
    portal: string;
    culture: string;
    articles: IArticleSuggestion[];
    flexibleSets: IFlexibleSetSuggestion[];
    contents: IContentSuggestion[];
    topSearchQueries: string[];
    featurePromotion?: string;
    customerType: CustomerEnum;
    searchTerm: string;
    isMobileShop: boolean;
    view: SearchboxViewType;
    searchTarget: string;
    priceMandantSettings: IPriceMandantSettings;
    priceMandantSettingsV2: IPriceMandantSettingsV2;
    pageViewLogDataId: string;
    deviceScrollClass: DeviceScrollEnum;
    deviceType: DeviceEnum;
}

export interface IPersonalizedSuggestionProps {
    isPersonalizedData: boolean;
    navigationRef: React.Ref<IHandleKeyboardNavigation>;
    trackingEndpoint: string;
    portal: string;
    culture: string;
    articles: IArticleSuggestion[];
    flexibleSets: IFlexibleSetSuggestion[];
    storedQueries: StoredSearchQuery[];
    contents: IContentSuggestion[];
    topSearchQueries: string[];
    featurePromotion?: string;
    customerType: CustomerEnum;
    isMobileShop: boolean;
    view: SearchboxViewType;
    searchTerm: string;
    searchTarget: string;
    priceMandantSettings: IPriceMandantSettings;
    priceMandantSettingsV2: IPriceMandantSettingsV2;
    pageViewLogDataId: string;
    deviceScrollClass: DeviceScrollEnum;
    deviceType: DeviceEnum;
    recoViewedEventSent: boolean;
}

export interface IMappedSuggestions {
    articles: IMappedArticle[];
    contentLinks: IMappedContent[];
    featurePromotion: IPromotion | null;
    topSearchQueries: IMappedTopSearchQuery[];
}

export enum DeviceScrollEnum {
    Desktop = "desktop-scroll",
    Kiosk = "kiosk-scroll",
    Tablet = "tablet-scroll",
    None = "no-scroll"
}
